export const visit = (vm, at) => {
vm(require("foundations-components/lang/el.lyaml"));
at({ "el": { "placeholder": "\u03BA\u03C1\u03AC\u03C4\u03B7\u03C3\u03B7 \u03B8\u03AD\u03C3\u03B7\u03C2" } });
};